import { render } from "./complete-actions-menu.vue?vue&type=template&id=7150f1a2&ts=true"
import script from "./complete-actions-menu.vue?vue&type=script&lang=ts"
export * from "./complete-actions-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__